<div class="card-header"></div>
<div class="main-content" [style.background-color]="viewModel.cardColor$ | async">
  <app-print-card-background-image-with-color-overlay-and-opacity [cardBackground]="cardBackground">
  </app-print-card-background-image-with-color-overlay-and-opacity>
</div>
